import { render } from "./EmailPreviewModal.vue?vue&type=template&id=64fa3939&scoped=true"
import script from "./EmailPreviewModal.vue?vue&type=script&lang=js"
export * from "./EmailPreviewModal.vue?vue&type=script&lang=js"

import "./EmailPreviewModal.vue?vue&type=style&index=0&id=64fa3939&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fa3939"]])

export default __exports__